export const texts = {
  'components/ConsentDeclaration': {
    label: {
      de: 'Schließen',
      'de-DU': 'Schließen',
      en_GB: 'Exit',
      hu: 'Bezárás',
    },
  },
  'components/Forms/ForgotPasswordFormByUserName': {
    userNameLabel: {
      de: 'Benutzername',
      'de-DU': 'Benutzername',
      en_GB: 'Username',
      hu: 'Felhasználónév',
    },
    userNameValidationError: {
      de: 'Bitte geben Sie Ihren Benutzernamen ein.',
      'de-DU': 'Bitte gib deinen Benutzernamen ein.',
      en_GB: 'Please enter your username.',
      hu: 'Adja meg felhasználónevét.',
    },
    submit: {
      de: 'E-Mail anfordern',
      'de-DU': 'E-Mail anfordern',
      en_GB: 'Request email',
      hu: 'E-Mail kérése',
    },
    emailSent: {
      de:
        'Falls uns der Benutzername bekannt ist, haben wir soeben eine E-Mail an die hinterlegte Adresse zur Vergabe eines neuen Passworts verschickt.',
      'de-DU':
        'Falls uns der Benutzername bekannt ist, haben wir soeben eine E-Mail an die hinterlegte Adresse zur Vergabe eines neuen Passworts verschickt.',
      en_GB:
        'If we have your username, we have just sent an email to the address provided for the purpose of resetting the password.',
      hu:
        'Ha ismerjük a felhasználónevet, akkor éppen most küldtünk egy új jelszót tartalmazó e-mailt a megadott címre.',
    },
    emailNotSent: {
      de:
        'E-Mail konnte nicht versendet werden. Bitte prüfen Sie Ihren Benutzernamen.',
      'de-DU':
        'E-Mail konnte nicht versendet werden. Bitte prüfe deinen Benutzernamen.',
      en_GB: 'Email could not be sent. Please check your username.',
      hu: 'Az e-mailt nem lehetett elküldeni. Ellenőrizze felhasználónevét.',
    },
    401: {
      de: 'Benutzername oder Passwort ist falsch.',
      'de-DU': 'Benutzername oder Passwort ist falsch.',
      en_GB: 'Username or password incorrect.',
      hu: 'A felhasználónév vagy a jelszó helytelen',
    },
    402: {
      de:
        'Ihr Zugang ist noch nicht aktiviert. Bitte aktivieren Sie ihn, bevor Sie sich anmelden.',
      'de-DU':
        'Dein Zugang ist noch nicht aktiviert. Bitte aktiviere ihn, bevor du dich anmeldest.',
      en_GB:
        'Your access has not yet been activated. Please activate it before signing in.',
      hu:
        'Hozzáférése még nincs aktiválva. Aktiválja azt a bejelentkezés előtt.',
    },
  },
  'components/Forms/ResetPasswordForm': {
    submit: {
      de: 'Speichern & anmelden',
      'de-DU': 'Speichern & anmelden',
      en_GB: 'Save & sign in',
      hu: 'Mentés & bejelentkezés',
    },
    errorUserNotFound: {
      de: 'Bitte prüfen Sie Ihren Benutzernamen.',
      'de-DU': 'Bitte prüfe deinen Benutzernamen.',
      en_GB: 'Please check your username.',
      hu: 'Ellenőrizze felhasználónevét.',
    },
    userNameLabel: {
      de: 'Benutzername',
      'de-DU': 'Benutzername',
      en_GB: 'Username',
      hu: 'Felhasználónév',
    },
    userNameValidationError: {
      de: 'Bitte geben Sie Ihren Benutzernamen ein.',
      'de-DU': 'Bitte gib deinen Benutzernamen ein.',
      en_GB: 'Please enter your username.',
      hu: 'Adja meg felhasználónevét.',
    },
    passwordLabel: {
      de: 'Passwort vergeben',
      'de-DU': 'Passwort vergeben',
      en_GB: 'Assign password',
      hu: 'Jelszó hozzárendelése',
    },
    passwordValidationError: {
      de: 'Ihr Passwort muss mindestens 8 Zeichen lang sein.',
      'de-DU': 'Dein Passwort muss mindestens 8 Zeichen lang sein.',
      en_GB: 'Your password must contain at least 8 characters.',
      hu: 'A jelszónak legalább 8 karakterből kell állnia.',
    },
    cPasswordLabel: {
      de: 'Passwort wiederholen',
      'de-DU': 'Passwort wiederholen',
      en_GB: 'Repeat password',
      hu: 'Jelszó ismétlése',
    },
    cPasswordValidationError: {
      de: 'Die Passwörter stimmen nicht überein.',
      'de-DU': 'Die Passwörter stimmen nicht überein.',
      en_GB: 'The passwords do not match.',
      hu: 'A jelszavak nem egyeznek.',
    },
    checkboxLabel: {
      de:
        'Ich bin mit der <a href="#datenschutz">Datenschutzerklärung</a> einverstanden.',
      'de-DU':
        'Ich bin mit der <a href="#datenschutz">Datenschutzerklärung</a> einverstanden.',
      en_GB: 'I agree to the <a href="#datenschutz">Privacy Policy</a>.',
      hu:
        'Egyetértek az <a href="#datenschutz">adatvédelmi nyilatkozatban foglaltakkal</a>.',
    },
  },

  'components/Forms/MultiPageForm': {
    back: {
      de: 'Zurück zu den Modulen',
      'de-DU': 'Zurück zu den Modulen',
      en_GB: 'Back to modules',
      hu: 'Vissza a modulokhoz',
    },
  },

  'components/Forms/MultiPageForm/FormSuccessPage': {
    back: {
      de: 'Weiter',
      'de-DU': 'Weiter',
      en_GB: 'Continue',
      hu: 'Bezárás',
    },
    message: {
      de: 'Vielen Dank! Ihre Eingaben wurden gespeichert.',
      'de-DU': 'Vielen Dank! Deine Eingaben wurden gespeichert.',
      en_GB: 'Thank you! Your entries were saved.',
      hu: 'Köszönjük, tároltuk a bevitt adatait.',
    },
  },

  'components/Forms/MultiPageForm/SummaryPage': {
    submit: {
      de: 'Speichern',
      'de-DU': 'Speichern',
      en_GB: 'Save',
      hu: 'Mentés',
    },
    questionLabel: {
      de: 'Frage',
      'de-DU': 'Frage',
      en_GB: 'Question',
      hu: 'Kérdés ',
    },
    answerLabel: {
      de: 'Antwort',
      'de-DU': 'Antwort',
      en_GB: 'Answer',
      hu: 'Válasz',
    },
    editLabel: {
      de: 'Bearbeiten',
      'de-DU': 'Bearbeiten',
      en_GB: 'Edit',
      hu: 'Szerkesztés',
    },
    summaryTitle: {
      de: 'Zusammenfassung',
      'de-DU': 'Zusammenfassung',
      en_GB: 'Summary',
      hu: 'Összegzés',
    },
    summaryTitleText: {
      en_GB:
        'Please check all your entries again. You can edit any incorrect entries by clicking on the pen icon next to your answer. <br /><br />If all entries are correct, confirm this by clicking on "Save". Afterwards, it is no longer possible to make changes.',
      de:
        'Bitte überprüfen Sie noch einmal alle Ihre Eingaben. Falsche Eingaben können Sie bearbeiten, indem Sie auf das Stiftsymbol neben Ihrer Antwort klicken. <br /><br />Sind alle Eingaben korrekt, bestätigen Sie dies mit einem Klick auf "Speichern". Danach ist es nicht mehr möglich, Änderungen vorzunehmen.',
      'de-DU':
        'Bitte überprüfen Sie noch einmal alle Ihre Eingaben. Falsche Eingaben können Sie bearbeiten, indem Sie auf das Stiftsymbol neben Ihrer Antwort klicken. <br /><br />Sind alle Eingaben korrekt, bestätigen Sie dies mit einem Klick auf "Speichern". Danach ist es nicht mehr möglich, Änderungen vorzunehmen.',
      hu:
        'Kérjük, ellenőrizze újra az összes bejegyzést. A hibás bejegyzéseket a válasza melletti ceruza ikonra kattintva szerkesztheti. <br /><br />Ha minden bejegyzés helyes, erősítse meg a "Mentés" gombra kattintva. Ezt követően már nincs lehetőség a módosításra.',
    },
    submitHint: {
      en_GB:
        '<b>Important: </b>By clicking on "Save" you confirm that the submitted data is accurate and correct.',
      de:
        '<b>Wichtig: </b>Wenn Sie auf "Speichern" klicken, bestätigen Sie, dass die eingegebenen Daten korrekt sind.',
      'de-DU':
        '<b>Wichtig: </b>Wenn Sie auf "Speichern" klicken, bestätigen Sie, dass die eingegebenen Daten korrekt sind.',
      hu:
        '<b>Fontos: </b>A "Mentés" gombra kattintva Ön megerősíti, hogy a megadott adatok pontosak és helyesek.',
    },
  },

  'components/Forms/SinglePageForm': {
    back: {
      de: 'Zurück zu den Modulen',
      'de-DU': 'Zurück zu den Modulen',
      en_GB: 'Back to modules',
      hu: 'Vissza a modulokhoz',
    },
  },

  'components/Forms/SinglePageForm/FormSuccessPage': {
    back: {
      de: 'Schließen',
      'de-DU': 'Schließen',
      en_GB: 'Exit',
      hu: 'Bezárás',
    },
    message: {
      de: 'Vielen Dank! Ihre Eingaben wurden gespeichert.',
      'de-DU': 'Vielen Dank! Deine Eingaben wurden gespeichert.',
      en_GB: 'Thank you! Your entries were saved.',
      hu: 'Köszönjük, tároltuk a bevitt adatait.',
    },
  },

  'components/Header': {
    greeting: {
      de: 'Hallo',
      'de-DU': 'Hallo',
      en_GB: 'Hi',
      hu: 'Üdv',
    },
  },
  'components/LoginForm': {
    signIn: {
      de: 'Anmelden',
      'de-DU': 'Anmelden',
      en_GB: 'Sign in',
      hu: 'Bejelentkezés',
    },
    forgotPassword: {
      de: 'Passwort vergeben',
      'de-DU': 'Passwort vergeben',
      en_GB: 'Assign password',
      hu: 'Jelszó hozzárendelése',
    },
    401: {
      de: 'Benutzername oder Passwort ist falsch',
      'de-DU': 'Benutzername oder Passwort ist falsch',
      en_GB: 'Username or password incorrect',
      hu: 'A felhasználónév vagy a jelszó helytelen',
    },
    402: {
      de:
        'Ihr Zugang ist noch nicht aktiviert. Bitte aktivieren Sie ihn, bevor Sie sich anmelden.',
      'de-DU':
        'Dein Zugang ist noch nicht aktiviert. Bitte aktiviere ihn, bevor du dich anmeldest.',
      en_GB:
        'Your access has not yet been activated. Please activate it before signing in.',
      hu:
        'Hozzáférése még nincs aktiválva. Aktiválja azt a bejelentkezés előtt.',
    },
    profileIdMissing: {
      de:
        'Ungültiger Link: Profil-ID fehlt bzw. ist fehlerhaft. Bitte prüfen Sie den Link, kopieren ihn vollständig und rufen ihn erneut auf. ',
      'de-DU':
        'Ungültiger Link: Profil-ID fehlt bzw. ist fehlerhaft. Bitte prüfen Sie den Link, kopieren ihn vollständig und rufen ihn erneut auf. ',
      en_GB:
        'Invalid link: profile ID missing or incorrect. Please check the link, copy it in full and try it again.',
      hu: '',
    },
    userNameLabel: {
      de: 'Benutzername',
      'de-DU': 'Benutzername',
      en_GB: 'Username',
      hu: 'Felhasználónév',
    },
    userNameValidationError: {
      de: 'Bitte geben Sie Ihren Benutzernamen ein.',
      'de-DU': 'Bitte gib deinen Benutzernamen ein.',
      en_GB: 'Please enter your username.',
      hu: 'Adja meg felhasználónevét.',
    },
    passwordLabel: {
      de: 'Passwort',
      'de-DU': 'Passwort',
      en_GB: 'Password',
      hu: 'Jelszó',
    },
    passwordValidationError: {
      de: 'Bitte geben Sie Ihr Passwort ein.',
      'de-DU': 'Bitte gib dein Passwort ein.',
      en_GB: 'Please enter your password.',
      hu: 'Adja meg jelszavát.',
    },
    checkboxLabel: {
      de:
        'Ich bin mit der <a href="#datenschutz">Datenschutzerklärung</a> einverstanden.',
      'de-DU':
        'Ich bin mit der <a href="#datenschutz">Datenschutzerklärung</a> einverstanden.',
      en_GB: 'I agree to the <a href="#datenschutz">Privacy Policy</a>.',
      hu:
        'Egyetértek az <a href="#datenschutz">adatvédelmi nyilatkozatban foglaltakkal</a>.',
    },
  },
  'components/RegistrationForm': {
    signIn: {
      de: 'Start',
      'de-DU': 'Start',
      en_GB: 'Start',
      hu: 'Bejelentkezés',
    },
    checkboxLabel: {
      de:
        'Ich bin mit der <a href="#datenschutz">Datenschutzerklärung</a> einverstanden.',
      'de-DU':
        'Ich bin mit der <a href="#datenschutz">Datenschutzerklärung</a> einverstanden.',
      en_GB: 'I agree to the <a href="#datenschutz">Privacy Policy</a>.',
      hu:
        'Egyetértek az <a href="#datenschutz">adatvédelmi nyilatkozatban foglaltakkal</a>.',
    },
  },
  'components/Navigation': {
    ProfileChooser: {
      de: 'Zur Übersicht',
      'de-DU': 'Zur Übersicht',
      en_GB: 'Overview',
      hu: 'Az áttekintéshez',
    },
    Home: {
      de: 'Module',
      'de-DU': 'Module',
      en_GB: 'Modules',
      hu: 'Modul',
    },
    FAQ: {
      de: 'FAQ',
      'de-DU': 'FAQ',
      en_GB: 'FAQ',
      hu: 'GYIK',
    },
    PasswordAendern: {
      de: 'Profil',
      'de-DU': 'Profil',
      en_GB: 'Profile',
    },
    Report: {
      de: 'Ergebnisse',
      'de-DU': 'Ergebnisse',
      en_GB: 'Results',
      hu: 'Eredmények',
    },
    ReportOnSite: {
      de: 'Ergebnisse',
      'de-DU': 'Ergebnisse',
      en_GB: 'Results',
      hu: 'Eredmények',
    },
    Support: {
      de: 'Support',
      'de-DU': 'Support',
      en_GB: 'Support',
      hu: 'Támogatás',
    },
    Logout: {
      de: 'Logout',
      'de-DU': 'Logout',
      en_GB: 'Logout',
      hu: 'Kijelentkezés',
    },
  },
  'components/VideoArchive': {
    videoArchiveLabel: {
      de: 'Videoarchiv:',
      'de-DU': 'Videoarchiv:',
      en_GB: 'video archive:',
      hu: 'video archive:', // TODO dev-975: übersetzen
    },
  },
  'views/ForgotPassword': {
    forgotPasswordTitle: {
      de: 'Passwort vergeben?',
      'de-DU': 'Passwort vergeben?',
      en_GB: 'Assign password?',
      hu: 'Jelszó hozzárendelése?',
    },
    forgotPasswordBody: {
      de:
        'Geben Sie Ihren Benutzernamen ein und fordern Sie eine E-Mail an, um sich ein Passwort zu vergeben.',
      'de-DU':
        'Gib deinen Benutzernamen ein und fordere eine E-Mail an, um dir ein Passwort zu vergeben.',
      en_GB:
        'Please enter your username and request an email to assign a password.',
      hu:
        'Adja meg felhasználónevét, és kérjen e-mailt a jelszó hozzárendeléséhez.',
    },
  },
  'views/Home/HomeTask': {
    startButtonText: {
      de: 'Starten',
      'de-DU': 'Starten',
      en_GB: 'Start',
      hu: 'Kezdés',
    },
    minutes: {
      de: 'Minuten',
      'de-DU': 'Minuten',
      en_GB: 'minutes',
      hu: 'Percek',
    },
  },
  'views/Home/UserNotification': {
    'default-title': {
      de: 'Glückwunsch, alles erledigt!',
      'de-DU': 'Glückwunsch, alles erledigt!',
      en_GB: 'Congratulations, all done!',
      hu: 'Gratulálunk, mindennel elkészült!',
    },
    'default-text': {
      de:
        'Sie haben alle Module abgeschlossen. Klicken Sie auf einen Menu-Button, um sich auszuloggen oder zurück zur Übersicht zu gelangen.',
      'de-DU':
        'Du hast alle Module abgeschlossen. Klicke auf einen Menu-Button, um dich auszuloggen oder zurück zur Übersicht zu gelangen.',
      en_GB:
        'You have completed all modules. Click on a Menu button to log out or return to the overview page.',
      hu:
        'Minden modult lezárt. A kijelentkezéshez vagy az áttekintéshez való visszatéréshez kattintson egy menü gombra.',
    },
    'onSite-title': {
      de: 'Glückwunsch, alles erledigt!',
      'de-DU': 'Glückwunsch, alles erledigt!',
      en_GB: 'Congratulations, all done!',
      hu: 'Gratulálunk, mindennel elkészült!',
    },
    'onSite-text': {
      de:
        'Sie haben alle Module abgeschlossen. Klicken Sie auf den Logout-Button, um sich auszuloggen.',
      'de-DU':
        'Du hast alle Module abgeschlossen. Klicke auf den Logout-Button, um dich auszuloggen.',
      en_GB:
        'You have completed all modules. Click on the Logout button to log out.',
      hu:
        'Minden modult lezárt. A kijelentkezéshez kattintson a Kijelentkezés gombra.',
    },
    'afterTraining-title': {
      de: 'Glückwunsch, alles erledigt!',
      'de-DU': 'Glückwunsch, alles erledigt!',
      en_GB: 'Congratulations, all done!',
      hu: 'Gratulálunk, mindennel elkészült!',
    },
    'afterTraining-text': {
      de: 'Sie haben alle Module absolviert.',
      'de-DU': 'Du hast alle Module absolviert.',
      en_GB: 'You have completed all modules.',
      hu: 'Az összes modult elvégezte.',
    },
  },
  'views/Home/UserNotificationWithReport': {
    'default-title': {
      de: 'Glückwunsch, alles erledigt!',
      'de-DU': 'Glückwunsch, alles erledigt!',
      en_GB: 'Congratulations, all done!',
      hu: 'Gratulálunk, mindennel elkészült!',
    },
    'default-text': {
      de:
        'Sie haben alle Module abgeschlossen. Klicken Sie auf einen Menu-Button, um Ihre Ergebnisse herunterzuladen, sich auszuloggen oder zurück zur Übersicht zu gelangen.',
      'de-DU':
        'Du hast alle Module abgeschlossen. Klicke auf einen Menu-Button, um deine Ergebnisse herunterzuladen, dich auszuloggen oder zurück zur Übersicht zu gelangen.',
      en_GB:
        'You have completed all modules. Click on a Menu button to download your results, log out or return to the overview page.',
      hu:
        'Minden modult lezárt. Az eredmények letöltéséhez, a kijelentkezéshez vagy az áttekintéshez való visszatéréshez kattintson egy menü gombra.',
    },
    'onSite-title': {
      de: 'Glückwunsch, alles erledigt!',
      'de-DU': 'Glückwunsch, alles erledigt!',
      en_GB: 'Congratulations, all done!',
      hu: 'Gratulálunk, mindennel elkészült!',
    },
    'onSite-text': {
      de:
        'Sie haben alle Module abgeschlossen. Klicken Sie auf einen Menu-Button, um Ihre Ergebnisse herunterzuladen oder sich auszuloggen.',
      'de-DU':
        'Du hast alle Module abgeschlossen. Klicke auf einen Menu-Button, um deine Ergebnisse herunterzuladen oder dich auszuloggen.',
      en_GB:
        'You have completed all modules. Click on a Menu button to download your results or log out.',
      hu:
        'Minden modult lezárt. Az eredmények letöltéséhez vagy a kijelentkezéshez kattintson egy menü gombra.',
    },
    'afterTraining-title': {
      de: 'Glückwunsch, alles erledigt!',
      'de-DU': 'Glückwunsch, alles erledigt!',
      en_GB: 'Congratulations, all done!',
      hu: 'Gratulálunk, mindennel elkészült!',
    },
    'afterTraining-text': {
      de: 'Sie haben alle Module absolviert.',
      'de-DU': 'Du hast alle Module absolviert.',
      en_GB: 'You have completed all modules.',
      hu: 'Az összes modult elvégezte.',
    },
  },
  'views/Home/UserNotificationSmartphone': {
    'default-title': {
      de: 'Glückwunsch, alles erledigt!',
      'de-DU': 'Glückwunsch, alles erledigt!',
      en_GB: 'Congratulations, all done!',
      hu: 'Gratulálunk, mindennel elkészült!',
    },
    'default-text': {
      de:
        'Sie haben alle Module abgeschlossen. Klicken Sie auf den Menu-Button, um sich auszuloggen oder zurück zur Übersicht zu gelangen.',
      'de-DU':
        'Du hast alle Module abgeschlossen. Klicke auf den Menu-Button um dich auszulogen oder zurück zur Übersicht zu gelangen.',
      en_GB:
        'You have completed all modules. Click on the Menu button to log out or return to the overview page.',
      hu:
        'Minden modult lezárt. A kijelentkezéshez vagy az áttekintéshez való visszatéréshez kattintson a menü gombra.',
    },
    'onSite-title': {
      de: 'Glückwunsch, alles erledigt!',
      'de-DU': 'Glückwunsch, alles erledigt!',
      en_GB: 'Congratulations, all done!',
      hu: 'Gratulálunk, mindennel elkészült!',
    },
    'onSite-text': {
      de:
        'Sie haben alle Module abgeschlossen. Klicken Sie auf den Menu-Button, um sich auszuloggen.',
      'de-DU':
        'Du hast alle Module abgeschlossen. Klicke auf den Menu-Button um dich auszulogen.',
      en_GB:
        'You have completed all modules. Click on the Menu button to log out.',
      hu: 'Minden modult lezárt. A kijelentkezéshez kattintson a menü gombra.',
    },
    'afterTraining-title': {
      de: 'Glückwunsch, alles erledigt!',
      'de-DU': 'Glückwunsch, alles erledigt!',
      en_GB: 'Congratulations, all done!',
      hu: 'Gratulálunk, mindennel elkészült!',
    },
    'afterTraining-text': {
      de: 'Sie haben alle Module absolviert.',
      'de-DU': 'Du hast alle Module absolviert.',
      en_GB: 'You have completed all modules.',
      hu: 'Az összes modult elvégezte.',
    },
  },
  'views/Home/UserNotificationSmartphoneWithReport': {
    'default-title': {
      de: 'Glückwunsch, alles erledigt!',
      'de-DU': 'Glückwunsch, alles erledigt!',
      en_GB: 'Congratulations, all done!',
      hu: 'Gratulálunk, mindennel elkészült!',
    },
    'default-text': {
      de:
        'Sie haben alle Module abgeschlossen. Klicken Sie auf den Menu-Button, um Ihre Ergebnisse herunterzuladen, sich auszuloggen oder zurück zur Übersicht zu gelangen.',
      'de-DU':
        'Du hast alle Module abgeschlossen. Klicke auf den Menu-Button um deine Ergebnisse heruterzuladen, dich auszulogen oder zurück zur Übersicht zu gelangen.',
      en_GB:
        'You have completed all modules. Click on the Menu button to download your results, log out or return to the overview page.',
      hu:
        'Minden modult lezárt. Az eredmények letöltéséhez, a kijelentkezéshez vagy az áttekintéshez való visszatéréshez kattintson a menü gombra.',
    },
    'onSite-title': {
      de: 'Glückwunsch, alles erledigt!',
      'de-DU': 'Glückwunsch, alles erledigt!',
      en_GB: 'Congratulations, all done!',
      hu: 'Gratulálunk, mindennel elkészült!',
    },
    'onSite-text': {
      de:
        'Sie haben alle Module abgeschlossen. Klicken Sie auf den Menu-Button, um Ihre Ergebnisse herunterzuladen oder sich auszuloggen.',
      'de-DU':
        'Du hast alle Module abgeschlossen. Klicke auf den Menu-Button um deine Ergebnisse heruterzuladen oder dich auszulogen.',
      en_GB:
        'You have completed all modules. Click on the Menu button to download your results or log out.',
      hu:
        'Minden modult lezárt. Az eredmények letöltéséhez vagy a kijelentkezéshez kattintson a menü gombra.',
    },
    'afterTraining-title': {
      de: 'Glückwunsch, alles erledigt!',
      'de-DU': 'Glückwunsch, alles erledigt!',
      en_GB: 'Congratulations, all done!',
      hu: 'Gratulálunk, mindennel elkészült!',
    },
    'afterTraining-text': {
      de: 'Sie haben alle Module absolviert.',
      'de-DU': 'Du hast alle Module absolviert.',
      en_GB: 'You have completed all modules.',
      hu: 'Az összes modult elvégezte.',
    },
  },

  'views/ModuleArea/ModuleTransition': {
    title: {
      de: 'Geschafft!',
      'de-DU': 'Geschafft!',
      en_GB: 'All done!',
      hu: 'Végeztél!',
    },
    back: {
      de: 'Zurück zu den Modulen',
      'de-DU': 'Zurück zu den Modulen',
      en_GB: 'Back to modules',
      hu: 'Vissza a modulokhoz',
    },
    description: {
      de:
        'Sie haben dieses Modul abgeschlossen. Ihre Ergebnisse wurden gespeichert.',
      'de-DU':
        'Du hast dieses Modul abgeschlossen. Deine Ergebnisse wurden gespeichert.',
      en_GB:
        'You have successfully completed this module. Your results have been saved.',
      hu: 'Ezt a modult befejezte. Eredményei mentésre kerültek.',
    },
    hintStart: {
      de: 'Tipp',
      'de-DU': 'Tipp',
      en_GB: 'Tip',
      hu: 'Tipp',
    },
    hint: {
      de:
        'Machen Sie eine kurze Pause, wenn Sie wollen. Eine kurze Unterbrechung kann helfen, konzentriert ins nächste Modul zu starten.',
      'de-DU':
        'Mach eine kurze Pause, wenn du willst. Eine kurze Unterbrechung kann helfen, konzentriert ins nächste Modul zu starten.',
      en_GB:
        'Take a break, if you like. You may find you focus better on the next module if you take a quick break before starting it.',
      hu:
        'Tartson egy rövid szünetet, ha úgy kívánja. Egy rövid megszakítás segíthet a következő modult koncentráltan elkezdeni.',
    },
    nextPreTitle: {
      de: 'Nächstes Modul',
      'de-DU': 'Nächstes Modul',
      en_GB: 'Next module',
      hu: 'Következő modul',
    },
    minuteAbbr: {
      de: 'Minuten',
      'de-DU': 'Minuten',
      en_GB: 'minutes',
      hu: 'Percek',
    },
  },
  'views/Login': {
    loginTitle: {
      de: 'Login',
      'de-DU': 'Login',
      en_GB: 'Login',
      hu: 'Belépés',
    },
  },
  'views/RegistrationAnon': {
    registerTitle: {
      de: 'Anonyme Registrierung',
      'de-DU': 'Anonyme Registrierung',
      en_GB: 'Anonymous registration',
      hu: 'Anonymous registration',
    },
    registerText: {
      de:
        'Ihre Verbindung wird nach 15 Minuten Inaktivität automatisch getrennt. Ihre Eingaben gehen dadurch verloren.',
      'de-DU':
        'Deine Verbindung wird nach 15 Minuten Inaktivität automatisch getrennt. Deine Eingaben gehen dadurch verloren.',
      en_GB:
        'Your connection will be automatically terminated after 15 minutes of inactivity. Your inputs will then be lost.',
      hu:
        'Ha 15 perig nem aktív, kapcsolata automatikusan megszakad. A bejegyzései ebben az esetben elvesznek.',
    },
  },
  'views/ModuleArea/ModuleContainerPreview': {
    minutes: {
      de: 'Minuten',
      'de-DU': 'Minuten',
      en_GB: 'minutes',
      hu: 'Percek',
    },
    startButtonText: {
      de: 'Starten',
      'de-DU': 'Starten',
      en_GB: 'Start',
      hu: 'Kezdés',
    },
    completed: {
      de: 'abgeschlossen',
      'de-DU': 'abgeschlossen',
      en_GB: 'completed',
      hu: 'elkészült',
    },
  },
  'views/PageNotFound': {
    buttonText: {
      de: 'Schließen',
      'de-DU': 'Schließen',
      en_GB: 'Exit',
      hu: 'Bezárás',
    },
    message: {
      de: 'Seite wurde nicht gefunden.',
      'de-DU': 'Seite wurde nicht gefunden.',
      en_GB: 'Page not found.',
      hu: 'Az oldal nem található.',
    },
  },
  'views/ProfileChooser/ProfileInfo': {
    startButtonText: {
      de: 'Starten',
      'de-DU': 'Starten',
      en_GB: 'Start',
      hu: 'Kezdés',
    },
    inactiveText: {
      de: 'Hier ist Ihre Bearbeitungszeit abgelaufen.',
      'de-DU': 'Hier ist deine Bearbeitungszeit abgelaufen.',
      en_GB: 'Your allotted time for this has expired.',
      hu: 'A feldolgozási idő lejárt.',
    },
    finishedText: {
      de:
        'Sie haben das Online-Assessment abgeschlossen. Ihre Ergebnisse wurden gespeichert.',
      'de-DU':
        'Du hast das Online-Assessment abgeschlossen. Deine Ergebnisse wurden gespeichert. ',
      en_GB:
        'You have completed the online assessment. Your results have been saved.',
      hu: 'Az online értékelést lezárta. Eredményeit elmentettük.',
    },
  },
  'views/ProfileChooser/ProfileInfoWithReport': {
    startButtonText: {
      de: 'Starten',
      'de-DU': 'Starten',
      en_GB: 'Start',
      hu: 'Kezdés',
    },
    inactiveText: {
      de: 'Hier ist Ihre Bearbeitungszeit abgelaufen.',
      'de-DU': 'Hier ist deine Bearbeitungszeit abgelaufen.',
      en_GB: 'Your allotted time for this has expired.',
      hu: 'A feldolgozási idő lejárt.',
    },
    finishedText: {
      de:
        'Sie haben das Online-Assessment abgeschlossen. Ihre Ergebnisse wurden gespeichert und können hier heruntergeladen werden.',
      'de-DU':
        'Du hast das Online-Assessment abgeschlossen. Deine Ergebnisse wurden gespeichert und können hier heruntergeladen werden.',
      en_GB:
        'You have completed the online assessment. Your results have been saved and can be downloaded here.',
      hu:
        'Az online értékelést lezárta. Eredményeit elmentettük, innen töltheti le őket.',
    },
  },
  'views/Progress': {
    registeredAt: {
      de: 'Registriert seit',
      'de-DU': 'Registriert seit',
      en_GB: 'Registered since',
      hu: 'Regisztrálva óta:',
    },
    progressStatement: {
      de: (count, total) => {
        return `${count} von ${total} abgeschlossen`;
      },
      'de-DU': (count, total) => {
        return `${count} von ${total} abgeschlossen`;
      },
      en_GB: (count, total) => {
        return `${count} of ${total} completed`;
      },
      hu: (count, total) => {
        return `${count} név ${total} befejezte`;
      },
    },
  },
  'views/Report': {
    title: {
      de: 'Ergebnisse',
      'de-DU': 'Ergebnisse',
      en_GB: 'Results',
      hu: 'Eredmények',
    },
    button: {
      de: 'Ergebnisbericht herunterladen',
      'de-DU': 'Ergebnisbericht herunterladen',
      en_GB: 'Download result report',
      hu: 'Eredményjelentés letöltése',
    },
    buttonLoading: {
      de: 'Bitte warten, wird geladen',
      'de-DU': 'Bitte warten, wird geladen',
      en_GB: 'Loading - please wait',
      hu: 'Kérjük, várjon, betöltődik',
    },
    downloadAllowedText: {
      de: 'Laden Sie hier Ihre Ergebnisse herunter.',
      'de-DU': 'Lade hier deine Ergebnisse herunter.',
      en_GB: 'Download your results here.',
      hu: 'Töltse le az eredményjelentést itt.',
    },
    downloadNotPossibleText: {
      de:
        'Erst wenn Sie alle Module abgeschlossen haben, steht Ihr Ergebnisbericht bereit.',
      'de-DU':
        'Erst wenn du alle Module abgeschlossen hast, steht dein Ergebnisbericht bereit.',
      en_GB:
        'Your result report is only available once you have completed all of the modules.',
      hu:
        'A jelentés csak akkor lesz elérhető, amikor az összes modult befejezte.',
    },
  },
  'views/ResetPassword': {
    resetTitle: {
      de: 'Passwort vergeben',
      'de-DU': 'Passwort vergeben',
      en_GB: 'Assign password',
      hu: 'Jelszó hozzárendelése',
    },
  },
  'views/ResetPasswordDiscover': {
    requirementsLoading: {
      de: 'Die Vorgaben für Ihr Passwort werden geladen',
      'de-DU': 'Die Vorgaben für Ihr Passwort werden geladen',
      en_GB: 'Password requirements are being loaded',
      hu: 'A jelszó alapértelmezett beállításai betöltődnek',
    },

    requirements: {
      de: 'Vorgaben für Ihr Passwort:',
      'de-DU': 'Vorgaben für Ihr Passwort:',
      en_GB: 'Password requirements:',
      hu: 'A jelszavára vonatkozó követelmények:',
    },

    charactersCount: {
      de: (chars) => `mindestens ${chars} Zeichen lang`,
      'de-DU': (chars) => `mindestens ${chars} Zeichen lang`,
      en_GB: (chars) => `min. ${chars} characters`,
      hu: (chars) => `legalább ${chars} karakter hosszúságú legyen`,
    },

    uppercaseCount: {
      de: (upper) => `mindestens ${upper} Großbuchstaben`,
      'de-DU': (upper) => `mindestens ${upper} Großbuchstaben`,
      en_GB: (upper) => `min. ${upper} uppercase letters`,
      hu: (upper) => `legalább ${upper} nagybetűt tartalmazzon`,
    },

    uppercaseCountOne: {
      de: 'mindestens ein Großbuchstabe',
      'de-DU': 'mindestens ein Großbuchstabe',
      en_GB: 'min. one uppercase letter',
      hu: 'legalább egy nagybetűt tartalmazzon',
    },

    lowercaseCount: {
      de: (lower) => `mindestens ${lower} Kleinbuchstaben`,
      'de-DU': (lower) => `mindestens ${lower} Kleinbuchstaben`,
      en_GB: (lower) => `min. ${lower} lowercase letters`,
      hu: (lower) => `legalább ${lower} kisbetűt tartalmazzon`,
    },
    lowercaseCountOne: {
      de: 'mindestens ein Kleinbuchstabe',
      'de-DU': 'mindestens ein Kleinbuchstabe',
      en_GB: 'min. one lowercase letter',
      hu: 'legalább egy kisbetűt tartalmazzon',
    },
    numbersCount: {
      de: (numbers) => `mindestens ${numbers} Zahlen`,
      'de-DU': (numbers) => `mindestens ${numbers} Zahlen`,
      en_GB: (numbers) => `min. ${numbers} numbers`,
      hu: (numbers) => `legalább ${numbers} számot tartalmazzon`,
    },
    numbersCountOne: {
      de: 'mindestens eine Zahl',
      'de-DU': 'mindestens eine Zahl',
      en_GB: 'min. one number',
      hu: 'legalább egy számot tartalmazzon',
    },
    noSpaces: {
      de: 'keine Leerzeichen',
      'de-DU': 'keine Leerzeichen',
      en_GB: 'no spaces',
      hu: 'ne legyenek benne szóközök',
    },
    noLineBreaks: {
      de: 'keine Zeilenumbrüche',
      'de-DU': 'keine Zeilenumbrüche',
      en_GB: 'no line breaks',
      hu: 'ne legyenek benne sortörések',
    },
    reenterPassword: {
      de: 'Bitte wiederholen Sie anschließend Ihr Passwort.',
      'de-DU': 'Bitte wiederholen Sie anschließend Ihr Passwort.',
      en_GB: 'Please re-enter your password.',
      hu: 'Kérjük, ezt követően ismételje meg jelszavát.',
    },
  },
};
